import { render, staticRenderFns } from "./ContentFilter.vue?vue&type=template&id=2596557d&"
import script from "./ContentFilter.vue?vue&type=script&lang=js&"
export * from "./ContentFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2596557d')) {
      api.createRecord('2596557d', component.options)
    } else {
      api.reload('2596557d', component.options)
    }
    module.hot.accept("./ContentFilter.vue?vue&type=template&id=2596557d&", function () {
      api.rerender('2596557d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/generic/ContentFilter.vue"
export default component.exports